module.exports = __webpack_public_path__ + "static/img/kim-carpenter-307030-unsplash.ba6001d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/kim-carpenter-307030-unsplash.png
// module id = aqV/
// module chunks = 37